import React, { useState, useEffect } from "react";
import TypingArea from "./TypingArea"; // Import the TypingArea component

const SpeedTypingGame = (props) => {
  let paragraphs = [
    "The rain poured down in torrents, drumming on rooftops and turning streets into rivers. People hurried by, umbrellas held high against the deluge, while cars splashed through puddles, sending waves of water. Inside, the warmth of the fire contrasted sharply with the cold and wet outside, and the smell of hot cocoa filled the air. It was a scene straight out of a movie, with dramatic lighting and intense emotions. Despite the chaos, there was a sense of calm and camaraderie among those huddled together, seeking refuge from the storm.",

    "In the early morning light, the garden was a symphony of colors. Roses, tulips, and daisies danced in the gentle breeze, petals glistening with dew. Birds chirped merrily from treetops, adding a sweet melody to the scene. The air was fresh and crisp, carrying the scent of blooming flowers and freshly cut grass. It was a picture-perfect moment, one that seemed to encapsulate the beauty and tranquility of nature. As the sun rose higher, casting long shadows across the landscape, it was hard not to feel awe and wonder at the world around us.",

    "Technology has advanced at an unprecedented rate over the past few decades. From the invention of the internet to the proliferation of smartphones, the way we live, work, and communicate has transformed. Every day, new innovations are introduced that change the landscape of our digital world, making it more interconnected and accessible. It's a testament to human ingenuity and creativity, as well as our insatiable desire for progress. But with great power comes great responsibility, and we must always be mindful of technology's impact on our lives and the world around us.",

    "The library was a sanctuary of silence, filled with the scent of old books and the soft rustle of pages turning. Sunlight filtered through large windows, casting a warm glow over rows of bookshelves. Students and scholars sat at wooden tables, absorbed in their studies, faces illuminated by the soft light of reading lamps. It was a scene straight out of a novel, with an air of quiet contemplation and intellectual curiosity. In a world filled with noise and distractions, the library was a refuge for those seeking knowledge and understanding.",

    "Traveling opens up a world of experiences and perspectives. Each destination offers a unique blend of culture, history, and natural beauty. From bustling streets of Tokyo to the serene beaches of the Maldives, every journey enriches the soul and broadens the mind. The memories made and lessons learned on the road are treasures that last a lifetime. Whether exploring ancient ruins or sampling exotic cuisines, traveling is an adventure that never fails to inspire and amaze.",

    "The mountains stood tall and majestic, their peaks dusted with snow. Below, a dense forest of pine trees stretched out, green needles shimmering in the sunlight. A river wound its way through the valley, waters clear and sparkling. The air was crisp and cool, filled with the scent of pine and birds calling. It was a scene straight out of a postcard, one that seemed too beautiful to be real. And yet, here it was, unfolding before my eyes in all its natural splendor.",

    "Cooking is both an art and a science. The right combination of ingredients, time, and technique can transform simple foods into delicious meals. From the careful selection of fresh produce to the precise timing of cooking steps, every detail matters. The joy of creating and sharing a meal is a universal pleasure that brings people together. Whether cooking for yourself or for loved ones, the act of preparing food is a deeply satisfying and rewarding experience. It's a way to nourish not just the body, but the soul as well.",

    "Music has the power to evoke emotions and memories. A single melody can transport you back in time to a specific moment or feeling. The rhythm, harmony, and lyrics blend together to create a tapestry of sound that speaks to the soul. Whether classical, jazz, rock, or pop, music is a universal language that connects us all. It's a form of expression that transcends boundaries and cultures, uniting people from all walks of life in a shared experience of joy and passion.",

    "Fitness and exercise are crucial for maintaining a healthy lifestyle. Regular physical activity strengthens the body, boosts the immune system, and improves mental health. Whether running, swimming, yoga, or weightlifting, finding an exercise routine you enjoy can make all the difference. Staying active enhances physical well-being and provides a sense of accomplishment and happiness. It's a way to challenge yourself, push your limits, and discover what you're truly capable of.",

    "The night sky was a canvas of stars, each one twinkling brightly against the dark expanse. The moon cast a silvery glow over the landscape, illuminating the trees and fields. In the distance, the sound of a lone owl hooting added a mysterious note to the quiet night. It was a perfect moment of peace and reflection, a reminder of the beauty and wonder of the natural world. As I gazed up at the stars, I couldn't help but feel a sense of awe and gratitude for the universe and its mysteries."
];


  const [typingText, setTypingText] = useState("");
  const [inpFieldValue, setInpFieldValue] = useState("");
  const maxTime = 60;
  const [timeLeft, setTimeLeft] = useState(maxTime);
  const [charIndex, setCharIndex] = useState(0);
  const [mistakes, setMistakes] = useState(0);
  const [isTyping, setIsTyping] = useState(false);
  const [WPM, setWPM] = useState(0);
  const [CPM, setCPM] = useState(0);

  const loadParagraph = () => {
    const ranIndex = Math.floor(Math.random() * paragraphs.length);
    const inputField = document.getElementsByClassName("input-field")[0];
    document.addEventListener("keydown", () => inputField.focus());
    const content = Array.from(paragraphs[ranIndex]).map((letter, index) => (
      <span
        key={index}
        style={{
          color: letter !== " " ? "black" : "transparent",
        }}
        className={`char ${index === 0 ? "active" : ""}`}
      >
        {letter !== " " ? letter : "_"}
      </span>
    ));
    setTypingText(content);
    setInpFieldValue("");
    setCharIndex(0);
    setMistakes(0);
    setIsTyping(false);
  };

  const handleKeyDown = (event) => {
    const characters = document.querySelectorAll(".char");
    if (
      event.key === "Backspace" &&
      charIndex > 0 &&
      charIndex < characters.length &&
      timeLeft > 0
    ) {
      if (characters[charIndex - 1].classList.contains("correct")) {
        characters[charIndex - 1].classList.remove("correct");
      }
      if (characters[charIndex - 1].classList.contains("wrong")) {
        characters[charIndex - 1].classList.remove("wrong");
        setMistakes(mistakes - 1);
      }
      characters[charIndex].classList.remove("active");
      characters[charIndex - 1].classList.add("active");
      setCharIndex(charIndex - 1);
      let cpm = (charIndex - mistakes - 1) * (60 / (maxTime - timeLeft));
      cpm = cpm < 0 || !cpm || cpm === Infinity ? 0 : cpm;
      setCPM(parseInt(cpm, 10));
      let wpm = Math.round(
        ((charIndex - mistakes) / 5 / (maxTime - timeLeft)) * 60
      );
      wpm = wpm < 0 || !wpm || wpm === Infinity ? 0 : wpm;
      setWPM(wpm);
    }
  };

  const initTyping = (event) => {
    const characters = document.querySelectorAll('.char');
    let typedChar = event.target.value.slice(-1); // Get the last typed character
    if (charIndex < characters.length && timeLeft > 0) {
      let currentChar = characters[charIndex].innerText;
      if (currentChar === '_') currentChar = ' ';
      if (!isTyping) {
        setIsTyping(true);
      }
      if (typedChar === currentChar) {
        setCharIndex(charIndex + 1);
        if (charIndex + 1 < characters.length) characters[charIndex + 1].classList.add('active');
        characters[charIndex].classList.remove('active');
        characters[charIndex].classList.add('correct');
      } else {
        setCharIndex(charIndex + 1);
        setMistakes(mistakes + 1);
        characters[charIndex].classList.remove('active');
        if (charIndex + 1 < characters.length) characters[charIndex + 1].classList.add('active');
        characters[charIndex].classList.add('wrong');
      }

      if (charIndex === characters.length - 1) setIsTyping(false);

      let wpm = Math.round(((charIndex - mistakes) / 5) / (maxTime - timeLeft) * 60);
      wpm = wpm < 0 || !wpm || wpm === Infinity ? 0 : wpm;
      setWPM(wpm);

      let cpm = (charIndex - mistakes) * (60 / (maxTime - timeLeft));
      cpm = cpm < 0 || !cpm || cpm === Infinity ? 0 : cpm;
      setCPM(parseInt(cpm, 10));
    } else {
      setIsTyping(false);
    }
  };

  const resetGame = () => {
    setIsTyping(false);
    setTimeLeft(maxTime);
    setCharIndex(0);
    setMistakes(0);
    setTypingText("");
    setCPM(0);
    setWPM(0);
    const characters = document.querySelectorAll(".char");
    characters.forEach((span) => {
      span.classList.remove("correct");
      span.classList.remove("wrong");
      span.classList.remove("active");
    });
    if (characters[0]) characters[0].classList.add("active");
    loadParagraph();
  };

  useEffect(() => {
    loadParagraph();
  }, []);

  useEffect(() => {
    let interval;
    if (isTyping && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft(timeLeft - 1);
        let cpm = (charIndex - mistakes) * (60 / (maxTime - timeLeft));
        cpm = cpm < 0 || !cpm || cpm === Infinity ? 0 : cpm;
        setCPM(parseInt(cpm, 10));
        let wpm = Math.round(
          ((charIndex - mistakes) / 5 / (maxTime - timeLeft)) * 60
        );
        wpm = wpm < 0 || !wpm || wpm === Infinity ? 0 : wpm;
        setWPM(wpm);
      }, 1000);
    } else if (timeLeft === 0) {
      clearInterval(interval);
      setIsTyping(false);
    }
    return () => {
      clearInterval(interval);
    };
  }, [isTyping, timeLeft]);

  return (
    <div className={props.mode}>
      <div className="mainContainer">
        <div className="heading">
          <h1><span>Speed Typer Pro</span> Race Against Time</h1>
        </div>
        <div className="remArea">
          <div className="container">
            <input
              type="text"
              className="input-field"
              value={inpFieldValue}
              onChange={(e) => {
                setInpFieldValue(e.target.value);
                initTyping(e);
              }}
              onKeyDown={handleKeyDown}
            />
            <TypingArea
              class="typingContainer"
              typingText={typingText}
              inpFieldValue={inpFieldValue}
              timeLeft={timeLeft}
              mistakes={mistakes}
              WPM={WPM}
              CPM={CPM}
              initTyping={initTyping}
              handleKeyDown={handleKeyDown}
              resetGame={resetGame}
            />
          </div>

        </div>

      </div>
    </div>
  );
};

export default SpeedTypingGame;
